
export default function leave( state = [], action = {} ){

	switch( action.type ){
		case 'GET_LEAVE_TYPE':
			return action.leave
		case 'SAVE_LEAVE':
			return action.leave
		case 'GET_LEAVE':
			return action.leave
		case 'DELETE_LEAVE':
			return action.leave
		case 'GET_LEAVE_BY_ID':
			return action.leave
		case 'UPDATE_LEAVE':
			return action.leave
		case 'UPLOADED_ATTACHMENT':
			return action.leave
		case 'GET_LEAVE_COMPANY':
			return action.leave
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/leave/leave.reducer.js